import { EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const usePlaylistsList = (queryVariables = {}, queryConfig = {}) => {
  const { data: playlists = [], ...queryResult } = useResourceList(
    { name: 'video-playlists', api: api.playlists },
    queryVariables,
    queryConfig,
  );

  return {
    playlists,
    latestVideos: queryResult.latestData,
    ...queryResult,
  };
};

export const usePlaylist = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['video-playlist', { id }], api.playlists.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    playlist: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const usePlaylistsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['video-playlists', { ids }], api.playlists.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    playlists: queryResult.data || [],
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'video-playlists' });

export const useDeletePlaylist = createMutation(api.playlists.remove);

export const useCreatePlaylist = createMutation(api.playlists.create);

export const useSavePlaylist = createMutation(api.playlists.save);

export const useUpdatePlaylist = createMutation(api.playlists.update);
